import { DEFAULT_CITY_CODE, normalizeCityCode, resolveLocationCityCode } from './cityCode';
import { COLDSTART_DEFAULT_CITY, effectiveSlotLabel, getActiveRegion } from './regionSlots';

function resolveCityCodeFromLabels(...labels) {
  for (const label of labels) {
    const text = String(label || '').trim();
    if (!text) continue;
    const code = resolveLocationCityCode(text);
    if (code !== DEFAULT_CITY_CODE) return code;
  }
  const fallback = labels.map((l) => String(l || '').trim()).find(Boolean);
  return resolveLocationCityCode(fallback || '');
}

/**
 * 활성 지역 SSOT — activeSource 기준 단일 출처.
 * @param {{
 *   gpsSlot: import('./regionSlots').LocationValue | null;
 *   pickSlot: import('./regionSlots').LocationValue | null;
 *   activeSource: 'gps' | 'pick';
 *   gpsSlotLabel?: string;
 *   pickSlotLabel?: string;
 *   locationCode?: string | null;
 * }} ctx
 * @returns {{ label: string; cityCode: string; countryCode: string; source: 'gps' | 'interest'; cityId: string | null }}
 */
export function buildActiveRegionView(ctx) {
  const {
    gpsSlot,
    pickSlot,
    activeSource,
    gpsSlotLabel = '',
    pickSlotLabel = '',
    gpsSlotSpecificLabel = '',
    pickSlotSpecificLabel = '',
    locationCode = '',
  } = ctx;
  const region = getActiveRegion(gpsSlot, pickSlot, activeSource, { allowFallback: false });
  const usePick = activeSource === 'pick' && pickSlot?.city_id === region?.city_id;
  const rawLabel = usePick
    ? effectiveSlotLabel(pickSlot, pickSlotLabel)
    : gpsSlotLabel || effectiveSlotLabel(region, '') || region?.city_label || '';
  const label = String(rawLabel || COLDSTART_DEFAULT_CITY.city_label || '').trim();
  // 가장 구체적인 지명만(구/군 있으면 그것만) — 날씨 위젯처럼 "도 이름"을 붙이면 어색한 곳에서 사용
  const rawSpecificLabel = usePick ? pickSlotSpecificLabel || rawLabel : gpsSlotSpecificLabel || rawLabel;
  const specificLabel = String(rawSpecificLabel || label).trim();
  const countryCode = String(region?.country_code || 'VN')
    .toUpperCase()
    .slice(0, 2);

  const slotCode = usePick ? pickSlot?.city_code : gpsSlot?.city_code;
  const hintedCode = normalizeCityCode(locationCode) || normalizeCityCode(slotCode);
  const cityCode =
    hintedCode ||
    resolveCityCodeFromLabels(
      label,
      region?.city_label,
      usePick ? pickSlot?.city_label : gpsSlot?.city_label,
      usePick ? pickSlotLabel : gpsSlotLabel,
    );

  const latVal = Number(region?.lat);
  const lngVal = Number(region?.lng);

  return {
    label,
    specificLabel,
    cityCode,
    countryCode,
    source: usePick ? 'interest' : 'gps',
    lat: Number.isFinite(latVal) ? latVal : null,
    lng: Number.isFinite(lngVal) ? lngVal : null,
    // locations.id (FK) — 원본 슬롯(LocationValue)엔 이미 있던 값인데 지금까지 여기서
    // 버려지고 label/cityCode 텍스트만 넘어갔음. "다낭"/"Da Nang" 같은 표기 차이로
    // 기본 지역필터가 안 맞는 문제를 막으려면 id로 매칭하는 게 정확하다.
    cityId: region?.city_id || null,
  };
}
